import { render, staticRenderFns } from "./top-bar.vue?vue&type=template&id=1f7bda4b&scoped=true&"
import script from "./top-bar.vue?vue&type=script&lang=js&"
export * from "./top-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7bda4b",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
